module.exports = __webpack_public_path__ + "img/work_from_home.e732b156.svg";